import {
  type
} from "os";
import CryptoJs from 'crypto-js'
import {
  Dialog
} from 'vant'

// 星期对应
const WEEK = ['日', '一', '二', '三', '四', '五', '六', '日', '一', '二', '三', '四', '五', '六']
// 在各位数字前加 0
const addZero = function(digit) {
  if (isNaN(digit)) {
    console.log('请传入数字变量')
    return
  }
  let digitStr = digit.toString()
  return digitStr[1] ? digitStr : '0' + digitStr
}

/**
 * 判断字符串是否为空
 * @param {val}  String\null\undefined\连续空格
 * @returns boolean true
 */
const isEmptyString = function(val) {
  return val == null || val === '' || /^\s+$/i.test(val)
}
// 去重
const uniqueBy = (arr, key) => {
  const seen = new Set();
  return arr.filter((item) => {
    const seenKey = item[key];
    return seen.has(seenKey) ? false : seen.add(seenKey);
  });
};
// 从url中提取微信回调code
const extractCodeWx = function(href) {
  let code = ''
  let reg = /code=(.+?)&/i
  let result = href.match(reg)
  console.log(result)
  result && (code = result[1])
  return code
}
// 从url中提取微信回调authCode
const extractAuthCodeWx = function(href) {
  let code = ''
  let reg = /authCode=(.+)&/i
  let result = href.match(reg)
  console.log(result)
  result && (code = result[1])
  return code
}
// 从url中提取支付宝信回调code
const extractCodeAli = function(href) {
  let code = ''
  let reg = /auth_code=(.+)$/i
  let result = href.match(reg)
  result && (code = result[1])
  return code
}
/**
 * 通过窗口userAgent判断运行环境
 */
const getEnvByUrl = function() {
  let agent = navigator.userAgent
  console.log('navigator.userAgent--', agent)
  if (agent.indexOf("MicroMessenger") != -1) {
    return 'wx'
  } else if (agent.indexOf("AlipayClient") != -1) {
    return 'ali'
  } else {
    return 'other'
  }
}

function cryptoEncrypt(origin, key, iv) {
  const keyWords = CryptoJS.enc.Utf8.parse(key),
    ivWords = CryptoJS.enc.Utf8.parse(iv)
  let options = {
    iv: ivWords
  }
  return CryptoJS.AES.encrypt(origin, keyWords, options).toString()
}
const storage = {

  setLocalstorage: function(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  getLocalstorage: function(key) {
    if (localStorage.getItem(key) != 'undefined' || localStorage.getItem(key) != 'null') {
      return JSON.parse(localStorage.getItem(key))
    } else {
      return null
    }
  },
  removeLocalstorage: function(key) {
    localStorage.removeItem(key)
  },
  setSessionstorage: function(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  getSessionstorage: function(key) {
    if (sessionStorage.getItem(key) != 'undefined' || sessionStorage.getItem(key) != 'null') {
      return JSON.parse(sessionStorage.getItem(key))
    } else {
      return null
    }
  },
  removeSessionstorage: function(key) {
    sessionStorage.removeItem(key)
  }
}
// 拼接get请求url
const joinFormUrl = function(api, parObj) {
  let strArray = []
  let str = ''
  if (Object.keys(parObj).length <= 0) {
    return api
  } else {
    for (let p in parObj) {
      if (parObj.hasOwnProperty(p)) {
        strArray.push(encodeURIComponent(p) + '=' + encodeURIComponent(parObj[p]))
      }
    }
    str = strArray.join('&')
    if (api.indexOf('?') !== -1) {
      return api + str
    } else {
      return api + '?' + str
    }
  }
}
// 伪深拷贝
const copyObj = function(obj) {
  return obj
}

// 时间戳转成时间格式字符串
// timeStamp-时间戳 tag-连接年月日的标志
// return 2018.05.07
const formatDateTime = function(timeStamp, tag) {
  if (!tag) {
    tag = '/'
  }
  (typeof timeStamp === 'string') && (timeStamp = Number(timeStamp))
  let date = new Date(timeStamp)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  return [y, m, d].map(addZero).join(tag)
}
// 时间戳转成时分格式字符串
// timeStamp-时间戳 tag-连接年月日的标志
// return 24:15
const formatDateTimeWithHM = function(timeStamp, tag = '/') {
  let date = new Date(timeStamp)
  let ymdStr = formatDateTime(timeStamp, tag)
  let h = date.getHours()
  let m = date.getMinutes()
  let hmStr = [h, m].map(addZero).join(':')

  return [ymdStr, hmStr].join(' ')
}
// 时间戳转成时分秒格式字符串
// timeStamp-时间戳 tag-连接年月日的标志
// return 24:15:17
const formatDateTimeWithHMS = function(timeStamp, tag = '/') {
  if ((typeof timeStamp != 'number') && (typeof timeStamp != 'string')) {
    console.log("timeStamp类型不对")
    return
  } else {
    // let date = 0
    (typeof timeStamp === 'string') && (timeStamp = Number(timeStamp))
    let date = new Date(timeStamp)
    let ymdStr = formatDateTime(timeStamp, tag)
    let h = date.getHours()
    let m = date.getMinutes()
    let s = date.getSeconds()
    let hmStr = [h, m, s].map(addZero).join(':')
    return [ymdStr, hmStr].join(' ')
  }

}
// timeStamp-时间戳 tag-连接年月日的标志
// return 24:15:17
const getYMDDate = function(timeStamp) {
  if ((typeof timeStamp != 'number') && (typeof timeStamp != 'string')) {
    throw "timeStamp类型不对"
  } else {
    (typeof timeStamp === 'string') && (timeStamp = Number(timeStamp))
    let date = new Date(timeStamp)
    let y = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    return `${y}${m > 9? m: '0' + m}${d > 9? d: '0' + d}`
  }
}
// 将20191001转换成2019-10-01
const YMD2Y_M_D = function(dateStr) {
  if (/^\d{8}$/.test(dateStr)) {
    return `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`
  } else {
    throw '请传入如20191001格式的日期字符串'
  }
}

/**
 * 获取中文的星期几
 * @param {Date/Numner} date或时间戳
 * @returns {String} '周一   周日'
 */
const getChineseWeekTxt = function(date) {
  if (!(date instanceof Date)) {
    if (typeof date === 'string') {
      let numberDate = Number(date)
      date = new Date(numberDate)
    }
    if (typeof date === 'number') {
      date = new Date(date)
    }
  }
  let weekIndex = date.getDay()
  return '周' + WEEK[weekIndex];
}

/**
 * 整数转成2位小数
 */
const formatToFloat = function(val) {
  let sNum = val
  let nNum = parseFloat(sNum)
  if (!isNaN(nNum)) {
    return nNum.toFixed(2)
  } else {
    return val
  }
}

/**
 * 验证手机号
 */
function checkPhone(tel) {
  var reg = /^1[3456789]\d{9}$/;
  if (reg.test(tel) && tel !== "") {
    return true;
  } else {
    return false;
  };
}

/**
 * 简单校验身份证号格式是否正确
 * @param {String} IDCard
 * @return Boolen
 */
const regIDCard = function(IDCard) {
  return /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(IDCard) ||
    /^\d{8}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/i.test(IDCard)
}

// 姓名脱敏
const formateName = function(name) {
  if (isEmptyString(name)) {
    console.log('参数name不能为空')
    return null
  } else {
    let length = name.length;
    let data = '';
    for (var i = 0; i < length - 1; i++) {
      data += '*'
    }
    data += (name.slice(length - 1, length))
    return data
  }
}

/**
 * 格式化身份证号，除开头四位和结尾三位外，中间其余用*代替
 * @param {String} IDCard
 * @returns 1234***********123
 */
const formateIDCard = function(IDCard) {
  if (isEmptyString(IDCard)) {
    console.log('参数idcard不能为空')
    return null
  } else {
    const reg = /^(.{1})(?:\d+)(.{1})$/ // 匹配身份证号前6位和后4位的正则表达式

    // return IDCard.replace(/^(\d{1})\d+(\d{1})$/, '$1****************$2')
    return IDCard.replace(reg, '$1****************$2')
  }
}


/**
 * 格式化电话号码，除开头三位和结尾四位外，中间其余用*代替
 * @param {String} phone
 * @returns 123****1234
 */
const formatePhone = function(phone) {
  if (isEmptyString(phone)) {
    console.log('参数phone不能为空')
    return null
  } else {
    return phone.replace(/^(\d{3})\d+(\d{4})$/, '$1****$2')
  }
}

/**
 * 住院信息历史记录相关操作
 */
const billHistory = {
  // newHistory 是整个历史记录，不是单个新添加的
  setAll(historyList) {
    storage.setLocalstorage('bill_history', historyList)
  },
  getAll() {
    return storage.getLocalstorage('bill_history') || []
  },
  // 更新历史记录-插入
  update(newHistory) {
    // 不存在则插入
    if (!this.existByVisitNo(newHistory.userIdCard)) {
      let billAll = this.getAll()
      if (billAll.length >= 5) {
        billAll.pop()
      }
      billAll.unshift(newHistory)
      this.setAll(billAll)
    } else {
      console.log("该查询历史已存在")
    }
  },
  // 删除某条历史记录,返回删除后新的历史记录
  deleteByVisitNo(userIdCard) {
    let billAll = this.getAll()
    for (let index in billAll) {
      if (billAll[index].userIdCard === userIdCard) {
        let deleted = billAll.splice(index, 1)
        break;
      }
    }
    this.setAll(billAll)
    return this.getAll()
  },
  // 根据住院号查找是否有该条历史记录，有的话返回该条信息
  getByVisitNo(userIdCard) {
    let billAll = this.getAll()
    // 找不到的话会返回undefined
    return billAll.filter(item => {
      return item.userIdCard === userIdCard
    })[0]
  },
  existByVisitNo(userIdCard) {
    return this.getByVisitNo(userIdCard) ? true : false
  }
}

/**
 * 检查信息历史记录相关操作
 */
const checkHistory = {
  // newHistory 是整个历史记录，不是单个新添加的
  setAll(checkList) {
    storage.setLocalstorage('check_history', checkList)
  },
  getAll() {
    return storage.getLocalstorage('check_history') || []
  },
  // 更新历史记录-插入
  update(newHistory) {
    // 不存在则插入
    if (!this.existByVisitNo(newHistory.visitNo)) {
      let billAll = this.getAll()
      if (billAll.length >= 5) {
        billAll.pop()
      }
      billAll.unshift(newHistory)
      this.setAll(billAll)
    } else {
      console.log("该查询历史已存在")
    }
  },
  // 删除某条历史记录,返回删除后新的历史记录
  deleteByVisitNo(visitNo) {
    let billAll = this.getAll()
    for (let index in billAll) {
      if (billAll[index].visitNo === visitNo) {
        let deleted = billAll.splice(index, 1)
        break;
      }
    }
    this.setAll(billAll)
    return this.getAll()
  },
  // 根据住院号查找是否有该条历史记录，有的话返回该条信息
  getByVisitNo(visitNo) {
    let billAll = this.getAll()
    // 找不到的话会返回undefined
    return billAll.filter(item => {
      return item.visitNo === visitNo
    })[0]
  },
  existByVisitNo(visitNo) {
    return this.getByVisitNo(visitNo) ? true : false
  }
}
/* 获取当前年月日 2020-03-16 */
const YMDFormat = function() {
  let clock = "";
  let d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  clock = year + "-" + month + "-" + day;
  return (clock);
}
/**
 * 获取来源 0 - 支付宝小程序 1- 微信公众号 3 诊间屏
 * @param {String/Numner} source
 */
const getSourceName = function(source) {
  switch (source.toString()) {
    case "0":
      return "支付宝小程序";
    case "1":
      return "微信公众号";
    case "3":
      return "诊间屏";
    default:
      return "未知"
  }
}


/**
 * 231,主任医师;232,副主任医师;233,主治医师;234,医师;235,医士
 * @param {String/Numner} source
 */
const gettitleCode = function(source) {
  switch (source.toString()) {
    case "231":
      return "主任医师";
    case "232":
      return "副主任医师";
    case "233":
      return "主治医师";
    case "234":
      return "医师";
    case "235":
      return "医士";
  }
}


// 1上午，2下午 3晚上4中午  5白天 6全天 7凌晨
// 排班标识名称
const getScheFlag = function(source) {
  switch (source.toString()) {
    case "1":
      return "上午";
    case "2":
      return "下午";
    case "3":
      return "晚上";
    case "4":
      return "中午";
    case "5":
      return "白天";
    case "6":
      return "全天";
    case "7":
      return "凌晨";
    default:
      return "未知"
  }
}

function locationPath() {
  return location.origin + location.pathname
}


// 健康卡方法如下
// 若其它页面切回到以前,将下面两个方法的路径该回去
// 电子健康卡到就诊人列表页
function healthPath() {
  // let path = '/patientList';//以前流程的就诊人列表
  let path = '/healthcard-list'; //电子健康卡列表
  return path
}

// 电子健康卡 到添加就诊人 选择有卡无卡页面
function healthBindPath() {
  // let path = '/patientadd';//以前流程的就诊人添加页面
  let path = '/wxpatientadd'; //电子健康卡添加页面
  return path
}
/**
 * 根据身份证号获取生日、性别
 * @param {string} idcard - 18位身份证号
 * @returns {object} 一个对象，包含生日birthday、性别gender
 */
function getInfoFromIdcard(idcard) {
  let y = idcard.substring(6, 10),
    m = idcard.substring(10, 12),
    d = idcard.substring(12, 14),
    birthday = `${y}-${m}-${d}`
  let lastNum = idcard[idcard.length - 2],
    gender = lastNum % 2 == 0 ? '女' : '男'
  return {
    birthday,
    gender
  }
}

/**
 * 根据身份证号计算年龄
 * @param {String} identityCard
 * @returns age
 */
const idCardAge = function(identityCard) {
  var len = (identityCard + '').length
  var strBirthday = ''
  if (len == 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len == 15) {
    var birthdayValue = ''
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7)
    if (parseInt(birthdayValue) < 10) {
      strBirthday =
        '20' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    } else {
      strBirthday =
        '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
    }
  }
  //时间字符串里，必须是“/”
  var birthDate = new Date(strBirthday)
  var nowDateTime = new Date()
  var age = nowDateTime.getFullYear() - birthDate.getFullYear()
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}

/**
 * 为预约挂号生成可选时间数据
 * @param {string} type - 挂号类型 0:预约 1:当日
 */
const initDateList = (type) => {
  // 明确天数逻辑：type为'0'生成未来7天，否则仅当天
  const totalDays = type === "0" ? 7 : 1;
  const dateList = [];

  // 基准日期（建议根据业务需求决定是否包含当天）
  const baseDate = new Date();

  // 根据业务需求调整起始日：
  // - 如果要包含当天：type为0时从0开始，否则0
  // - 如果要生成明天开始的7天：type为0时从1开始
  const startOffset = type === "0" ? 1 : 0;

  for (let i = 0; i < totalDays; i++) {
    // 创建不可变日期对象（避免污染原始日期）
    const currentDate = new Date(baseDate);
    currentDate.setDate(baseDate.getDate() + startOffset + i);

    // 统一日期处理逻辑
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    // 生成日期对象
    dateList.push({
      md: `${month}/${day}`, // 月/日格式
      week: getChineseWeekTxt(currentDate), // 星期获取函数
      timeStamp: currentDate.getTime(), // 时间戳
      formattedDate: `${year}-${month}-${day}` // ISO格式
    });
  }

  return dateList;
}
const wxAddCardUrl = function(uid, type) {
  if (type == '0') {
    return `https://card.wecity.qq.com/dispatcher-plus/bindInfo?appid=wxa9fbca210400238a&cityCode=410100&uid=${uid}&channel=AAH5KTYKDxHQZe-q4qEc7UI2`;
  } else {
    let redirectUrl = `${location.protocol}//${location.host}${location.pathname}/#/addCardHealth`
    return `https://weapp.th.qq.com/open/archive/authorize?partnerId=80000012&cityCode=410100&redirectUrl=${encodeURIComponent(redirectUrl)}&channel=AAHnQowlJ7f4ZwdtcL16wsPq&isMultiple=false`
  }
}
/**
 * 微信医保电子凭证建档
 */
function toAuthUrl() {
  let redirectUrl = encodeURIComponent('https://zzsdyrmyy.cyjysoft.com/#/patientCardWxMiAdd'),
    appid = 'wxa9fbca210400238a'

  // console.log(`https://card.wecity.qq.com/openAuth/info?authType=2&isDepart=2&appid=${appid}&cityCode=410100&channel=AAEMmQy8fP4teWxUfpRDh8bG&redirectUrl=${redirectUrl}`);
  // this.$router.push('/patientCardWxMiAdd')
  location.href =
    `https://card.wecity.qq.com/openAuth/info?authType=2&isDepart=2&appid=${appid}&cityCode=410100&channel=AAEMmQy8fP4teWxUfpRDh8bG&redirectUrl=${redirectUrl}`
}

/**
 * 计算各种挂号方式到首页的页面栈深度
 */
function calculateRouterDeepth() {
  const routerregtype = storage.getSessionstorage('routerregtype') // 各种挂号流程
  let deepth = 0
  switch (routerregtype) {
    case 'normal': // 主流挂号流程：首页-选科室-选医生-选号源-确认
    case 'searchdoctor': // 搜索医生挂号：首页-选科室-搜索医生-选号源-确认-支付
      deepth = 5
      break
    case 'searchdept': // 搜索科室挂号：首页-选科室-搜索科室-选医生-选号源-确认-支付
      deepth = 6
      break
    case 'lastreg': // 上次挂号医生挂号：首页-选科室(选上次挂号的医生)-选号源-确认-支付
    case 'doctorcollect': // 收藏医生挂号：首页-收藏的医生-选号源-确认-支付
      deepth = 4
      break
    case 'record': // 继续支付：挂号记录-记录详情-支付
      deepth = 2 // 返回记录页
      break
    case 'doctorcard': // 医生名片挂号：扫医生名片-选号源-确认-支付
      deepth = 0
      break
  }
  return deepth
}

const getItemTypeName = function(itemType) {
  const obj = {
    "00": "挂号费",
    "01": "西药费",
    "02": "中成药",
    "03": "中草药",
    "04": "检验费",
    "05": "治疗费",
    "06": "手术费",
    "07": "输血费",
    "08": "输氧费",
    "09": "换药费",
    "10": "其他",
    "11": "放射费",
    "12": "CT费",
    "13": "B超",
    "14": "彩超",
    "15": "心电图",
    "16": "脑地形图",
    "17": "检查费",
    "18": "急诊留观",
    "19": "一次材料费",
    "20": "监护费",
    "21": "抢救费",
    "22": "降温费",
    "23": "取暖费",
    "24": "接生费",
    "25": "处置费",
    "26": "疫苗针",
    "27": "注射费",
    "28": "病理费",
    "29": "彩色多普勒",
    "30": "诊察费",
    "31": "床位费",
    "32": "护理费",
    "33": "麻醉费",
    "34": "动态心电",
    "35": "核医学检查",
    "36": "体检费",
    "37": "会诊费",
    "38": "卫生材料费",
    "39": "理疗费",
    "40": "纤维镜检查",
    "41": "救护车费",
    "42": "司法鉴定费",
    "43": "核磁共振费",
    "81": "其它"
  }

  let itemTypeName = obj[itemType] ? obj[itemType] : '未知'
  return itemTypeName
}

// 本人医保支付
const getYbPayUrl = function(routePath) {

  const orgChnlCrtfCodg = encodeURIComponent(
    'BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxsR81fEV6R0cZ+atrM5siY9'
  ) // 机构渠道认证编码
  const orgCodg = 'H41160200064' // 定点医药机构编码
  // const orgAppId = '1GBM54COG01E3F60C80A0000795760D1' // 定点医药机构应用ID 测试
  const orgAppId = '1IR14LPI109M8D430B0A0000153EBBB3' // 定点医药机构应用ID 正式

  const {
    pathname
  } = location
  let redirect_uri = `https://zsyy.zksrmyy.cn${pathname}#${routePath}`

  redirect_uri = encodeURIComponent(redirect_uri)
  // 免密授权
  // const hostName = 'mitest' // 测试域名
  const hostName = 'card' // 正式域名
  return `https://${hostName}.wecity.qq.com/oauth/code?authType=2&isDepart=2&bizType=04107&appid=wx0aa808dbb128895b&cityCode=411601&channel=AAFlEGAvgWOW71CicowWbxkc&orgChnlCrtfCodg=${orgChnlCrtfCodg}&orgCodg=${orgCodg}&orgAppId=${orgAppId}&redirectUrl=${redirect_uri}`
}
// 医保亲情付
const getFamilyYbPayUrl = function(routePath, patientName, sfz) {
  if (!sfz) {
    Dialog.alert({
      message: '就诊人身份证号不存在'
    })
    return new Error('请先完善身份证号')
  }
  // familyId: 就诊亲属的姓名+身份证后四位，如“赵钱0311”
  const originFamilyId = patientName + sfz.substring(sfz.length - 4)
  console.log('originFamilyId======',originFamilyId)
  const familyId = CryptoJs.MD5(originFamilyId).toString()
  console.log('familyId======',familyId)
  const orgChnlCrtfCodg = encodeURIComponent(
    'BqK1kMStlhVDgN2uHf4EsLK/F2LjZPYJ81nK2eYQqxsR81fEV6R0cZ+atrM5siY9'
  ) // 机构渠道认证编码
  const orgCodg = 'H41160200064' // 定点医药机构编码
  // const orgAppId = '1GBM54COG01E3F60C80A0000795760D1' // 定点医药机构应用ID 测试
  const orgAppId = '1IR14LPI109M8D430B0A0000153EBBB3' // 定点医药机构应用ID 正式

  const {
    pathname
  } = location
  let redirect_uri = `https://zsyy.zksrmyy.cn${pathname}#${routePath}`

  redirect_uri = encodeURIComponent(redirect_uri)
  console.log('redirect_uri======',redirect_uri)
  // 免密授权
  // const hostName = 'mitest' // 测试域名
  const hostName = 'card' // 正式域名
  return `https://${hostName}.wecity.qq.com/oauth/code?authType=2&isDepart=2&bizType=04107&appid=wx0aa808dbb128895b&cityCode=411601&familyId=${familyId}&channel=AAFlEGAvgWOW71CicowWbxkc&orgChnlCrtfCodg=${orgChnlCrtfCodg}&orgCodg=${orgCodg}&orgAppId=${orgAppId}&redirectUrl=${redirect_uri}`
}
//获取当前日期7天前的日期
const getDays = function toEnd(num) {
  let myDate = new Date()
  myDate.setDate(myDate.getDate() - num)
  return formatDateTime(myDate, '-')
}
const debounce = function(fn, delay) {
  let timer = null;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}
export {
  formateName,
  getInfoFromIdcard,
  idCardAge,
  wxAddCardUrl,
  toAuthUrl,
  isEmptyString,
  extractCodeWx,
  extractAuthCodeWx,
  extractCodeAli,
  getEnvByUrl,
  storage,
  joinFormUrl,
  copyObj,
  formatDateTime,
  formatDateTimeWithHM,
  formatDateTimeWithHMS,
  getYMDDate,
  YMD2Y_M_D,
  getChineseWeekTxt,
  addZero,
  formatToFloat,
  formateIDCard,
  formatePhone,
  regIDCard,
  checkPhone,
  billHistory,
  checkHistory,
  YMDFormat,
  getSourceName,
  locationPath,
  healthPath,
  healthBindPath,
  cryptoEncrypt,
  initDateList,
  uniqueBy,
  gettitleCode,
  getScheFlag,
  calculateRouterDeepth,
  getItemTypeName,
  getYbPayUrl,
  getFamilyYbPayUrl,
  getDays,
  debounce
}



// WEBPACK FOOTER //
// ./src/js/common.js